import { watch, onActivated } from "vue";
import { useRoute } from "vue-router";
import { useNewLanguageEffect } from "@/effects/switchLanguageEffect";

/** 解析 URL 参数 ?lang=en / ?lang=zh / ?lang=tw / ?lang=ms */
export const normalizeLangFromQuery = (lang) => {
  const value = String(lang || "")
    .trim()
    .toLowerCase()
    .replace(/_/g, "-");
  if (value === "en" || value === "en-us") return "en-US";
  if (value === "zh" || value === "zh-cn" || value === "cn") return "zh-CN";
  if (value === "tw" || value === "zh-tw" || value === "zh-hant") return "zh-TW";
  if (value === "ms" || value === "ms-my" || value === "my") return "ms-MY";
  return "";
};

/**
 * 根据路由 query.lang 切换界面语言（vue-i18n + Vant）
 * 支持：?lang=en、?lang=zh、?lang=tw
 */
export const useRouteLangQueryEffect = () => {
  const route = useRoute();
  const { onSystemChangeLanguage } = useNewLanguageEffect();

  const applyLangFromRoute = () => {
    const nextLang = normalizeLangFromQuery(route.query.lang);
    if (nextLang) onSystemChangeLanguage(nextLang);
  };

  watch(() => route.query.lang, applyLangFromRoute, { immediate: true });
  onActivated(applyLangFromRoute);

  return { applyLangFromRoute, normalizeLangFromQuery };
};
